import styles from './Confusion.module.css';

const labelMap = {
  TP: 'True Spam',
  TN: 'True Non-Spam',
  FP: 'False Spam',
  FN: 'False Non-Spam'
};

export default function Confusion({ className, data }){
  return (
    <div className={`${styles['wrap']} ${className}`}>
        <header>Confusion Matrix</header>
        <div className={`${styles.container}`}>
            {data.map(({ modelName, confusionDetail }, index) => {
                const total = Object.values(confusionDetail).reduce((sum, v) => sum + v, 0);

                const getColorOpacity = (count) => {
                    const ratio = count / total;
                    return `rgba(0, 123, 255, ${ratio})`;
                };

                return (
                    <div key={index} className={styles.modelBlock}>
                        <div className={styles.grid}>
                            {['TP', 'FP', 'FN', 'TN'].map((key) => {
                                const count = confusionDetail[key] || 0;
                                const percent = ((count / total) * 100).toFixed(1);
                                return (
                                    <div
                                      key={key}
                                      className={styles.cell}
                                      style={{ backgroundColor: getColorOpacity(count) }}
                                    >
                                      <div className={styles.label}>{labelMap[key]}</div>
                                      <div className={styles.value}>{count} ({percent}%)</div>
                                    </div>
                                );
                            })}
                        </div>
                        <div className={styles.modelName}>{modelName}</div>
                    </div>
                );
            })}
        </div>
    </div>
  );
};